import { InjectionToken } from '@angular/core';

/**
 * @const APP_IDENTITY
 * Injection token for the application identifier to be provided by the applications.
 */
export const APP_IDENTITY: InjectionToken<string> = new InjectionToken('APP_IDENTITY');
